angular.module('public.security-manager.employee').component('gccsEmployeeProfileApproveClientPreview', {
  template: require('./template.pug'),
  controller: 'EmployeeClientApproveClientPreviewController',
  bindings: {
    client: '<',
    employee: '<',
    isSelected: '<'
  }
});
